import { Typography } from '@euler/app/components/typography';
import { ApdmImportSummary } from '@euler/functions/apdm/import/importState';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useState } from 'react';
import { View } from 'react-native';
import { useTheme } from 'styled-components';
import { BusiestMonths } from './BusiestMonths';
import { LeftOutDetails } from './LeftOutDetails';
import { LeftOutLine } from './LeftOutLine';
import { RoutineBreakdown } from './RoutineBreakdown';
import { SummaryStats } from './SummaryStats';

/**
 * What the import will bring in. Details of what was left out stay folded
 * unless too much was.
 */
export function ImportSummary({ summary }: { summary: ApdmImportSummary }) {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  const [expanded, setExpanded] = useState(summary.detailsOpen);
  return (
    <View>
      <SummaryStats summary={summary} />
      {summary.completionAssumed ? (
        <Typography.Text
          size={rpx(13)}
          color={theme.label.color}
          style={{ marginTop: rpx(8) }}
        >
          文件里没有单据状态，所有记录都按已完工导入。
        </Typography.Text>
      ) : null}
      {summary.vehicleList ? (
        <Typography.Text
          size={rpx(13)}
          color={theme.label.color}
          style={{ marginTop: rpx(8) }}
        >
          这是车辆列表：每辆车按最近一次来店计一次到店，不知道做了什么项目；同一天如有服务记录，以服务记录为准。
        </Typography.Text>
      ) : null}
      {summary.contactList ? (
        <Typography.Text
          size={rpx(13)}
          color={theme.label.color}
          style={{ marginTop: rpx(8) }}
        >
          这是客户名单：只导入了车牌，没有到店记录，可以用来给名单里的客户发消息。
        </Typography.Text>
      ) : null}
      <RoutineBreakdown routine={summary.routine} />
      <BusiestMonths months={summary.busiestMonths} />
      <LeftOutLine
        leftOut={summary.leftOut}
        expanded={expanded}
        onToggle={() => setExpanded(value => !value)}
      />
      {expanded ? <LeftOutDetails leftOut={summary.leftOut} /> : null}
    </View>
  );
}
